import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getFirestore } from 'firebase/firestore'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'

const firebaseConfig = {
  apiKey: "AIzaSyDyWbHWqesR8s4G6ReUjHMqAjLLkFkwFSI",
  authDomain: "leel-8b535.firebaseapp.com",
  projectId: "leel-8b535",
  storageBucket: "leel-8b535.firebasestorage.app",
  messagingSenderId: "737336883114",
  appId: "1:737336883114:web:46c7aa99974122bcc65dd3",
  measurementId: "G-WH681QZF72"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Analytics (only in browser)
let analytics = null
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app)
}

// Initialize Firestore
const db = getFirestore(app)

// Initialize Auth
const auth = getAuth(app)
const googleProvider = new GoogleAuthProvider()

export { app, analytics, db, auth, googleProvider }
